import { render, staticRenderFns } from "./StrategyManager.vue?vue&type=template&id=5cacdad4&"
import script from "./StrategyManager.vue?vue&type=script&lang=js&"
export * from "./StrategyManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports